import { useContext } from 'react';
import { ChatbotContext } from './Chatbot.context';
import type { ChatbotContextValue } from './Chatbot.types';

export const useChatbot = (): ChatbotContextValue => {
  const ctx = useContext(ChatbotContext);
  if (!ctx) throw new Error('useChatbotContext must be used within <ChatbotProvider>');
  return ctx;
};
